/**
 * Normalizes staff role.permissions from API or persisted session (array or JSON string).
 */
export function normalizeStaffPermissionList(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw as string[]
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw) as unknown
      return Array.isArray(parsed) ? (parsed as string[]) : []
    } catch {
      return []
    }
  }
  return []
}
